module.exports = __webpack_public_path__ + "static/media/providerGoldTop2M.186b1e20.webp";